/**
 * What a team role's key, name and description may be (ADR 0003). The web
 * form, the gateway and auth-service check the same limits, and the
 * database refuses a key outside the pattern too (`roles_key_format`).
 */
export const ROLE_KEY_PATTERN = /^[A-Z][A-Z0-9_]{1,39}$/;
export const ROLE_NAME_MAX = 60;
export const ROLE_DESCRIPTION_MAX = 300;
/** How far down the lists a role may be placed; fits the int32 on the wire. */
export const ROLE_POSITION_MAX = 10_000;
